import { createRouter, createWebHistory } from "vue-router";

// Public pages 
// Using Home.vue which already has responsive handling
import Home from "@/views/public/Home.vue";

// Admin pages
import AdminDashboard from "@/views/admin/DashboardQuasar.vue";

// Routes configuration
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "Home - Best Coupon Deals & Discounts" },
  },
  {
    path: "/store/:slug",
    name: "Store",
    component: () => import("@/views/public/StoreQuasar.vue"),
    meta: { title: "Store Coupons & Deals" },
  },
  {
    path: "/category/:slug",
    name: "Category",
    component: () => import("@/views/public/CategoryQuasar.vue"),
    meta: { title: "Category Coupons & Deals" },
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/public/SearchQuasar.vue"),
    meta: { title: "Search Results" },
  },
  {
    path: "/stores",
    name: "Stores",
    component: () => import("@/views/public/StoresQuasar.vue"),
    meta: { title: "All Stores" },
  },
  {
    path: "/coupons",
    name: "Coupons",
    component: () => import("@/views/public/CouponsQuasar.vue"),
    meta: { title: "Latest Deals & Coupons" },
  },  {
    path: "/featured",
    name: "Featured",
    component: () => import("@/views/public/FeaturedQuasar.vue"),
    meta: { title: "Featured Deals" },
  },  {
    path: "/categories",
    name: "Categories",
    component: () => import("@/views/public/CategoriesQuasar.vue"),
    meta: { title: "All Categories" },
  },  {
    path: "/menu",
    redirect: "/featured",
    meta: { title: "Menu Options" }
  },
  {
    path: "/about",
    name: "AboutUs",
    component: () => import("@/views/public/AboutUsQuasar.vue"),
    meta: {
      title: "About CouponLa – India's Best Coupons, Deals & Offers Platform"
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/public/Contact.vue"),
    meta: {
      title: "Contact Us - Get in Touch with CouponLa"
    }
  },
  {
    path: '/contact-us',
    redirect: '/contact',
  },
  {
    path: '/privacy-policy',
    name: 'Privacy',
    component: () => import('@/views/public/Privacy.vue')
  },
  {
    path: '/terms-of-service',
    name: 'Terms',
    component: () => import('@/views/public/Terms.vue')
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminDashboard,
    meta: { requiresAuth: true, title: "Admin Dashboard" },
    children: [
      {
        path: "",
        name: "AdminOverview",
        component: () => import("@/views/admin/OverviewQuasar.vue"),
        meta: { requiresAuth: true, title: "Dashboard Overview" },
      },
      {
        path: "dashboard",
        name: "AdminDashboard",
        component: () => import("@/views/admin/OverviewQuasar.vue"),
        meta: { requiresAuth: true, title: "Dashboard Overview" },
      },
      {
        path: "coupons",
        name: "AdminCoupons",
        component: () => import("@/views/admin/CouponsQuasar.vue"),
        meta: { requiresAuth: true, title: "Manage Coupons" },
      },
      {
        path: "bulk-upload",
        name: "AdminBulkUpload",
        component: () => import("@/views/admin/BulkUploadQuasar.vue"),
        meta: { requiresAuth: true, title: "Bulk Upload Coupons" },
      },
      {
        path: "stores",
        name: "AdminStores",
        component: () => import("@/views/admin/StoresQuasar.vue"),
        meta: { requiresAuth: true, title: "Manage Stores" },
      },
      {
        path: "categories",
        name: "AdminCategories",
        component: () => import("@/views/admin/CategoriesQuasar.vue"),
        meta: { requiresAuth: true, title: "Manage Categories" },
      },
      {
        path: "analytics",
        name: "AdminAnalytics",
        component: () => import("@/views/admin/AnalyticsQuasar.vue"),
        meta: { requiresAuth: true, title: "Analytics Dashboard" },
      },      {
        path: "media-manager",
        name: "AdminMediaManager",
        component: () => import("@/views/admin/MediaManagerQuasar.vue"),
        meta: { requiresAuth: true, title: "Media Manager" },
      },
      {
        path: "error-logs",
        name: "AdminErrorLogs",
        component: () => import("@/views/admin/ErrorLogsQuasar.vue"),
        meta: { requiresAuth: true, title: "Error Logs & Cache Stats" },
      },
      // Super Admin Routes
      {
        path: "admins",
        name: "AdminUsers",
        component: () => import("@/views/admin/AdminUsersQuasar.vue"),
        meta: { 
          requiresAuth: true, 
          requiresSuperAdmin: true, 
          title: "Admin Users Management" 
        },
      },      {
        path: "system",
        name: "SystemSettings",
        component: () => import("@/views/admin/SystemSettingsQuasar.vue"),
        meta: { 
          requiresAuth: true, 
          requiresSuperAdmin: true, 
          title: "System Settings" 
        },
      },      {
        path: "data-integrity",
        name: "DataIntegrityReport",
        component: () => import("@/views/admin/DataIntegrityReportQuasar.vue"),
        meta: {
          requiresAuth: true,
          requiresSuperAdmin: true,
          title: "Data Integrity Report"
        },
      },
      {
        path: "banners",
        name: "BannerManager",
        component: () => import("@/views/admin/BannerManagerQuasar.vue"),
        meta: {
          requiresAuth: true,
          title: "Banner Manager"
        },
      },
    ],  },  {
    path: "/admin/login",
    name: "Login",
    component: () => import("@/views/admin/LoginQuasar.vue"),
    meta: { title: "Admin Login" },
  },
  {
    path: "/login",
    redirect: "/admin/login",
  },  // Admin routes fallback - simply show dashboard for any unknown paths
  {
    path: "/admin/:pathMatch(.*)*",
    component: AdminDashboard,
    props: { showDashboard: true },
    meta: { requiresAuth: true, title: "Admin Dashboard" }
  },  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/admin/LoginQuasar.vue"),
    meta: { title: "Reset Password" },
  },
  {
    path: "/settings/pwa",
    name: "PwaSettings",
    component: () => import("@/views/public/PwaSettingsView.vue"),
    meta: { title: "PWA Settings" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/public/NotFoundQuasar.vue"),
    meta: { title: "Page Not Found" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Navigation guard for route title and authentication
router.beforeEach((to, from, next) => {
  try {
    // Set page title
    if (typeof document !== 'undefined') {
      document.title = to.meta.title || "Coupon Affiliate Website";
    }
    
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      let isLoggedIn = false;
      
      try {
        const userDataStr = localStorage.getItem("user");
        isLoggedIn = typeof localStorage !== 'undefined' && userDataStr !== null;
        
        if (isLoggedIn) {
          const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin) || to.path.startsWith('/admin');
          const requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
          
          let adminStatusData;
          try {
            const storedAdminStatus = localStorage.getItem("adminStatus");
            adminStatusData = storedAdminStatus ? JSON.parse(storedAdminStatus) : null;
          } catch {
            adminStatusData = null;
          }
          
          const isAdmin = adminStatusData?.isAdmin === true;
          const isSuperAdmin = adminStatusData?.isSuperAdmin === true;
          
          if (requiresAdmin && !isAdmin) {
            next({ name: "Login", query: { error: 'unauthorized' } });
            return;
          }
          
          if (requiresSuperAdmin && !isSuperAdmin) {
            next({ name: "Admin" });
            return;
          }
        }
      } catch {
        isLoggedIn = false;
      }

      if (!isLoggedIn) {
        const redirectPath = encodeURIComponent(to.fullPath);
        next({ name: "Login", query: { redirect: redirectPath } });
      } else {
        next();
      }
    } else {
      next();
    }
  } catch (error) {
    console.error("Navigation guard error:", error);
    next();
  }
});

export default router;
